<template>
    <div class="flex">
        <div :class="{'': showMenu, 'hidden': !showMenu}" class="md:hidden">
            <div class="fixed inset-0 flex z-40">
                <transition
                    duration="300"
                    enter-active-class="transition-opacity ease-linear duration-300"
                    enter-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="transition-opacity ease-linear duration-300"
                    leave-class="opacity-100"
                    leave-to-class="opacity-0"
                >
                    <div
                        v-show="sidebarVisible"
                        class="fixed inset-0"
                        @click="close"
                    >
                        <div class="absolute inset-0 stage-sidebar-dark opacity-80"></div>
                    </div>
                </transition>
                <transition
                    enter-active-class="transition ease-in-out duration-300 transform"
                    enter-class="-translate-x-full"
                    enter-to-class="translate-x-0"
                    leave-active-class="transition ease-in-out duration-300 transform"
                    leave-class="translate-x-0"
                    leave-to-class="-translate-x-full"
                    @before-enter="beforeToggleSidebar"
                    @after-leave="afterToggleSidebar"
                >
                    <div
                        v-show="sidebarVisible"
                        class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 stage-sidebar-dark"
                    >
                        <div class="mt-5 flex-1 h-0 flex flex-col">
                            <nav class="px-6 pt-1 flex-1 pb-6 overflow-y-auto">
                                <menu-list mobile></menu-list>
                            </nav>
                            <div class="stage-sidebar-user-wrap pb-10 px-8">
                                <sidebar-user-menu></sidebar-user-menu>
                            </div>
                        </div>
                    </div>
                </transition>
                <div class="flex-shrink-0 w-14"></div>
            </div>
        </div>
        <div class="hidden md:flex md:flex-shrink-0">
            <div :class="[collapsed ? 'w-24' : 'w-72']" class="flex flex-col transition-all duration-200 ease-in-out">
                <div class="relative flex h-18 flex-shrink-0 items-center stage-sidebar-dark">
                    <button
                        :aria-label="collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
                        class="sidebar-toggle-btn"
                        type="button"
                        @click.stop="$emit('toggleMenuCollapsed')"
                    >
                        <svg-vue aria-hidden="true" class="sidebar-toggle-shape" icon="gui.menu_toggle"></svg-vue>
                        <svg-vue aria-hidden="true" class="sidebar-toggle-icon" icon="font-awesome.regular.ellipsis-vertical"></svg-vue>
                    </button>
                    <router-link
                        :class="[collapsed ? 'justify-center px-0' : 'px-12']"
                        class="flex items-center h-full w-full"
                        to="/tickets/list"
                    >
                        <logo :compact-image-class="'w-14 h-14 object-contain'" :divPadding="'px-0'" :compact="collapsed"></logo>
                    </router-link>
                </div>
                <div class="h-0 flex-1 flex flex-col stage-sidebar-dark">
                    <nav :class="collapsed ? 'px-2 pt-1 flex-1 pb-6 overflow-y-auto stage-sidebar-scroll-desktop' : 'px-4 pt-1 flex-1 pb-6 overflow-y-auto stage-sidebar-scroll-desktop'" class="transition-all duration-200 ease-in-out">
                        <menu-list :collapsed="collapsed"></menu-list>
                    </nav>
                    <div :class="collapsed ? 'stage-sidebar-user-wrap flex justify-center pb-10 px-0' : 'stage-sidebar-user-wrap pb-10 px-8'">
                        <sidebar-user-menu :collapsed="collapsed"></sidebar-user-menu>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Logo from "@/components/layout/shared/logo_invert";
import MenuList from "@/components/layout/customer/menu/menu-list";
import SidebarUserMenu from "@/components/layout/shared/sidebar-user-menu";

export default {
    name: "customer-sidebar",
    components: {MenuList, Logo, SidebarUserMenu},
    props: {
        sidebarVisible: {
            type: Boolean,
            required: true,
        },
        collapsed: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            showMenu: false,
        };
    },
    watch: {
        $route() {
            this.$emit('toggleSidebar', false);
        }
    },
    methods: {
        close() {
            this.$emit('toggleSidebar', false);
        },
        beforeToggleSidebar() {
            this.showMenu = true;
        },
        afterToggleSidebar() {
            this.showMenu = false;
        }
    }
}
</script>
